export const SET_SELECTED_OPTIONS = "SET_SELECTED_OPTIONS";
export const SET_OFFICE_NETWORK_COMMENTS = "SET_OFFICE_NETWORK_COMMENTS";

export const setSelectedOptions = (options) => ({
  type: SET_SELECTED_OPTIONS,
  payload: options,
});

export const setOfficeNetworkComments = (comments) => ({
    type: SET_OFFICE_NETWORK_COMMENTS,
    payload: comments,
  });

